class LoadMore extends HTMLElement {
constructor() {
    super()

    this.container = this.dataset.container;
    this.pagination = this.getAttribute('id');
    this.loadingText = this.dataset.loadingText || '';
    this.loadMoreBtn = this;
    this.loadMoreProductsCount = document.querySelector('.load-more__products-count');
    this.trigger = null;

    this.loadMoreBtn.addEventListener('click', (e) => {
      this.trigger = e.pointerType;
    })

    if (this.loadMoreBtn.querySelector('a')) {
      new Ajaxinate(
      {
          container: `#${this.container}`,
          pagination: `#${this.pagination}`,
          loadingText: this.loadingText,
          method: 'click',
          callback: () => {
            this.progressBar = `.load-progress-bar[data-pagination-id="${this.pagination}"]`;
            this.loadedProducts = document.querySelector(this.progressBar).getAttribute('products-amount');

            // handleFeaturedItems();

            var progressBar = new ProgressBar();
            progressBar.updateWidth(this.trigger, this.loadedProducts, this.loadMoreBtn);

            if (typeof checkSubcollectionTextOverflow == 'function') {
              checkSubcollectionTextOverflow()
            }
          }
      }
      );
    } else {
      this.loadMoreBtn.style.display = "none";
      // this.gridItemsCount = document.querySelectorAll('.grid__item:not(.grid__item--featured)').length;
      // this.loadMoreProductsCount.innerHTML = this.gridItemsCount;
    }

    const handleFeaturedItems = () => {
      const featuredItems = document.querySelectorAll('.grid__item--featured');
      let flag = false;
      featuredItems.forEach(item => {
        if (window.getComputedStyle(item).getPropertyValue('display') !== 'none') {
          if (flag) {
            item.style.display = 'none';
          } else {
            flag = true;
          }
        }
      })
    }
  }
}
customElements.define('load-more', LoadMore);
